import '.c6{position:relative;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.i4{border-radius:20px;}.ssr-plugin'
import '.ay{border:var(--blue-border);}.ssr-plugin'
import '.c9{padding:1.5rem;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.j6{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.gl{width:2rem;}.ssr-plugin'
import '.ev{height:2rem;}.ssr-plugin'
import '.f1{border-radius:50%;}.ssr-plugin'
import '.j7{border:1px solid var(--shades-blue-800);}.ssr-plugin'
import '.j{display:flex;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.aw{flex-shrink:0;}.ssr-plugin'
import '.j8{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="c6 ah i4 ay c9 a0 j6"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--shades-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="gl ev f1 j7 j k r aw j8"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--shades-blue-800)',
                height: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--shades-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
